import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import ProductCategoryList from "./ProductCategoryList";
import ProductCategoryForm from "./ProductCategoryForm";
import { ADD_NEW } from "constants/commonConstants";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import categoryReducer from "store/Masters/Category/reducer";
import categorySaga from "store/Masters/Category/saga";
import productCategoryReducer from "store/Masters/ProductCategory/reducer";
import productCategorySaga from "store/Masters/ProductCategory/saga";

const categoryKey = "CategoryMaster";

const withCategoryReducer = injectReducer({
  key: categoryKey,
  reducer: categoryReducer,
});
const withCategorySaga = injectSaga({ key: categoryKey, saga: categorySaga });

const productCategoryKey = "ProductCategoryMaster";

const withProductCategoryReducer = injectReducer({
  key: productCategoryKey,
  reducer: productCategoryReducer,
});
const withProductCategorySaga = injectSaga({
  key: productCategoryKey,
  saga: productCategorySaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      productCategoryData: null,
    };

    this.validator = new SimpleReactValidator();
  }

  onProductCategoryInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
      productCategoryData: null,
    });
  };

  viewProductCategory = (productCategory) => {
    this.setState({
      formDialog: true,
      productCategoryData: productCategory,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <ProductCategoryForm
            formDialog={this.state.formDialog}
            productCategoryRecord={this.state.productCategoryData}
            closeModal={() => this.onProductCategoryInsertUpdateSuccess()}
          ></ProductCategoryForm>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between flex-column flex-sm-row">
                    <h4 className="mt-0 page-title">Product Category</h4>
                    <button
                      className="my-2 btn btn-primary waves-effect waves-light float-right"
                      onClick={() => this.viewProductCategory(null)}
                    >
                      {ADD_NEW}
                    </button>
                  </div>

                  <ProductCategoryList
                    onViewProductCategory={(values) =>
                      this.viewProductCategory(values)
                    }
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default compose(
  withCategoryReducer,
  withCategorySaga,
  withProductCategoryReducer,
  withProductCategorySaga,
  withRouter
)(Index);
